/* eslint-disable */
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import StatesList from './StatesList';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import { getStatesListPagination, addStateData, getStateData, editStateData, resetState, resetStatesList } from '../actions/masterManagementAction';
import { SET_STATE } from '../../../common/constants/ActionTypes';

const StateForm = ({ addState, setAddState, setStateName, stateName }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange"
  });

  const onSubmit = (data, addState, setAddState) => {
    let requestBody = {
      "stateDto": {
        "name": data.stateName,
        "countryid": 88,
        "isActive": data.isActive,
        "isDeleted": false
      }
    };
    dispatch(resetStatesList());
    if (addState.Mode == 'Add') {
      dispatch(addStateData(requestBody, setAddState, setStateName));
    }
    else if (addState.Mode == 'Edit') {
      requestBody.stateDto.code = addState.statecode;
      dispatch(editStateData(requestBody, setAddState, setStateName));
    }
  }


  useEffect(() => {
    if (addState && addState.Mode == 'Add') {
      dispatch(resetStatesList());
      setStateName('');
    }

    addState.Mode == "Edit" && addState.statecode > 0 && dispatch(getStateData(addState.statecode));

    dispatch({
      type: SET_STATE,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])

  const { stateData } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setStateName('');
    dispatch(resetState());
    dispatch(resetStatesList());
    dispatch(getStatesListPagination(0, 10, ''));
    setAddState({ "Mode": false });
  }

  return addState.Mode == false ? (
    <div>
      <StatesList
        setAddState={setAddState}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addState.Mode == 'Add' ? masterLabels.statesForm.Add_State : masterLabels.statesForm.Update_State}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-5'>
                <label className='font-weight-bold float-left' >{masterLabels.statesForm.Name}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="stateName"
                  placeholder={masterLabels.statesForm.Name}
                  ref={register({ required: true, maxLength: 300 })}
                  defaultValue={addState && addState.Mode == 'Edit' && addState.stateName ? addState.stateName : ''}
                  onChange={(event) => setStateName(event.target.value)}
                />
                {_.get("stateName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("stateName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
                )}
              </div>
              <div className='col-md-5 d-none' >
                <label className='font-weight-bold float-left' >{masterLabels.statesForm.Transalations}</label>
                <input
                  className="form-control"
                  rows={3}
                  cols={5}
                  name="translations"
                  placeholder={masterLabels.statesForm.Transalations}
                  defaultValue={stateData && stateData.stateDto && stateData.stateDto.translations}
                  ref={register({ maxLength: 500 })}
                />

              </div>
              <div className='col-md-1 d-flex align-items-center gap-2'>
                <input
                  className='float-left text-left'
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={stateData && stateData.stateDto && stateData.stateDto.isActive}
                  ref={register({})}
                />
                <label className='float-left font-weight-bold text-left'>{masterLabels.statesForm.Status}?&nbsp;&nbsp;</label>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="button" className="btn btn-secondary " onClick={() => onCancelButton()}>
                  {commonLabels.BUTTON_CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button  ms-2  " onClick={handleSubmit((e) => { onSubmit(e, addState, setAddState); })}>
                  {commonLabels.BUTTON_SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default StateForm;